import {
  getStream,
  getStreamProducts,
  getAttraction,
  getProducts
} from '@/calls/event';
import { getLikes } from '@/calls/likes';

const event = {
  namespaced: true,
  state: {
    requests: 0,
    item: null,
    liked: false,
    products: null
  },
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
    setLike(state, liked) {
      state.liked = liked;
    },
    setProducts(state, products) {
      state.products = products;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    },
    updateLikes(state, likes) {
      state.item.likes = likes;
    }
  },
  actions: {
    async get({ commit }, id) {
      commit('increaseRequests');

      const request = await getAttraction(id);

      if (request.success) {
        commit('setItem', request.data);
      }

      commit('decreaseRequests');
    },
    async getStreaming({ commit }, id) {
      commit('increaseRequests');

      const request = await getStream(id);

      if (request.success) {
        commit('setItem', request.data);
      }

      commit('decreaseRequests');
    },
    async getProducts({ commit }, id) {
      commit('increaseRequests');

      const request = await getProducts(id);

      if (request.success) {
        commit('setProducts', request.data);
      }

      commit('decreaseRequests');
    },
    async getStreamingProducts({ commit }, id) {
      commit('increaseRequests');

      const request = await getStreamProducts(id);

      if (request.success) {
        commit('setProducts', request.data);
      }

      commit('decreaseRequests');
    },
    async updateLikes({ commit, state }) {
      const request = await getLikes(state.item.id);

      if (request.success) {
        commit('updateLikes', request.data);
      }
    },
    reset({ commit }) {
      commit('setItem', null);
      commit('setProducts', null);
    }
  }
};

export default event;
